import { useQuery } from '@tanstack/vue-query'
import { getUnreadNotificationCount } from '@/features/notifications/api/get-unread-notification-count'
import { NOTIFICATIONS_QUERY_KEY } from '@/features/notifications/queries/keys'

/**
 * New notifications arrive over the socket (see `useNotificationSocket`). This is the safety net for
 * when the socket is down, and for reads and deletes in other tabs, which aren't pushed.
 */
const POLL_INTERVAL_MS = 180_000

export function useUnreadNotificationCount() {
  return useQuery({
    queryKey: [...NOTIFICATIONS_QUERY_KEY, 'unread-count'],
    queryFn: getUnreadNotificationCount,
    refetchInterval: POLL_INTERVAL_MS,
  })
}
